






















import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import Banner from "@/zh-website/src/components/website/Swiper/Banner.vue";
import SideBar from "@/zh-website/src/components/website/SideBar.vue";
import { CommonService } from "@/zh-website/src/views/Enterprise/service/CommonService";
@Component({
  components: {
    Banner,
    SideBar
  }
})
export default class SuccessCaseDetail extends Vue {
  CaseDetail = {} as any;

  mounted() {
    this.getCustomDetail();
  }

  getCustomDetail() {
    const id = this.$route.params.id;
    CommonService.getCustomDetail({id: id, type: 2}).then(
      (res: any) => {
        this.CaseDetail = res.data;
      }
    );
  }
}
